import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { KlmrFuelPage } from '../klmr-fuel/klmr-fuel';
import { SearchPage } from '../search/search';
import { SelectHireMachinePage } from '../select-hire-machine/select-hire-machine';

@IonicPage()
@Component({
  selector: 'page-klmr-fuel-add',
  templateUrl: 'klmr-fuel-add.html',
})
export class KlmrFuelAddPage {
  fleetList: any = [];
  filledByList: any = [];
  fuelLocationList: any = [];
  containerList: any = [
    // "Truck",
    // "Gerry Cans",
    "Pod",
  ];
  fuelList: any = [
    "Diesel",
    // "Unleaded",
  ];
  serviceStationList: any = [
    "Service 1",
    "Service 2",
    "Service 3",
    "Service 4",
    "Service 5",
  ];
  serviceStationName: any = "";
  selectedLocation: any = "Select";
  // selectedFLEET: any = "Select";
  selectedFleet: any = "Select";
  selectedFuel: any;
  selectedConatiner: any;
  filledBy: any;
  selectOptions: any;
  createFuel: FormGroup;
  isUpdate: boolean = false;
  params: any = {};
  appColor: String;
  actionAllowed: boolean = false;
  showOtherLocatiion: boolean = false;

  perLitreAmount: any = null;

  disableSubmit:boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider, private formBuilder: FormBuilder, private modalController: ModalController) {
    this.selectOptions = {
      mode: 'ios'
    };
    this.params = this.navParams.get('param');
    if (this.params) {
      this.isUpdate = true;

    }
    let currentDate = new Date()
     var d = new Date();
  // let aeest = d.toLocaleString( "en-US", { timeZone: "Australia/Sydney"});
  // let year = d.toLocaleString( "default", { year: "numeric" ,timeZone: "Australia/Sydney"});
  // let month = d.toLocaleString( "default", { month: "2-digit" ,timeZone: "Australia/Sydney"});
  // let day = d.toLocaleString( "default", { day: "2-digit" ,timeZone: "Australia/Sydney"});
  // var date = year + "-" + month + "-" + day;

  var d = new Date();
  let aeest = d.toLocaleString( "en-US", { timeZone: "Australia/Sydney"});
  let year = d.toLocaleString( "default", { year: "numeric" ,timeZone: "Australia/Sydney"});
  let month = d.toLocaleString( "default", { month: "2-digit" ,timeZone: "Australia/Sydney"});
  let day = d.toLocaleString( "default", { day: "2-digit" ,timeZone: "Australia/Sydney"});
  var date = year + "-" + month + "-" + day;
  console.log("aeest",aeest);
  console.log("date",date);
  console.log("formattedDate",date);
    this.createFuel = this.formBuilder.group({
      filled_by: new FormControl('', [Validators.required]),
      user_id: new FormControl('', [Validators.required]),
      date: new FormControl(date, [Validators.required]),
      odometer: new FormControl('', [Validators.required]),
      diesel: new FormControl('Diesel', [Validators.required]),
      container: new FormControl('Pod', [Validators.required]),
      fleet_no: new FormControl('', [Validators.required]),
      fuel: new FormControl('', [Validators.required]),
      amount: new FormControl(''),
      fuel_odr: new FormControl(''),
      center_per_litre: new FormControl(''),
      other_location: new FormControl(''),
      fleet_vahicle_type: new FormControl(''),
      fleet_description: new FormControl(''),
      location: new FormControl('', [Validators.required]),
      

      // fuel_station: new FormControl('Service 1', [Validators.required]),
    });
    console.log("param", this.params)
  }

  ionViewDidLoad() {
    this.getPermission();
    this.getappColor();
    this.getMetaData();

  }

  async getappColor() {
    this.appColor = await this.utiltiy.getStorage("primaryColor");
    let userName = await this.utiltiy.getStorage("name");
    let userId = await this.utiltiy.getStorage("userId");
    let fuelLocationList = await this.getFuelLocationList();

    this.fuelLocationList  = [...[{"location":"Other","id":"other"}],...fuelLocationList];
    console.log("this.fuelLocationList",this.fuelLocationList)
    if (userName) {
      // this.createFuel.get(`filled_by`).setValue(userName);
      this.createFuel.get(`user_id`).setValue(userId);
      // this.filledBy = userName;
      this.createFuel.get(`filled_by`).setValue(userId);
      this.filledBy = userId;
    }
  }
  async getMetaData() {
    let fleetList = await this.getFleetList();
    this.fleetList  = [...[{"fleet_no":"Hire Machine","id":"hire_machine"}],...fleetList];
    console.log("fleetList",this.fleetList )
    this.filledByList = await this.getFilledBtList();
    if (this.params) {
      this.regenerateForm();
      this.getCentrePerLitre();
      this.regenerateFleetList();
      if(this.params.fleet_no == "hire_machine"){
        this.selectedFleet = "Hire Machine";
      }
    }
  }

  async createData(list, key, value) {
    list.forEach(element => {
      element.key = element[key];
      element.value = element[value];
    });

    return list;
  }

  regenerateFleetList(){
    let index = this.fleetList.findIndex(list_ => list_['id'] == this.params.fleet_no);
    if(index != -1){
      this.selectedFleet = this.fleetList[index].fleet_no;
    }
  }

  async openModal(list, title, key, value, model, formkey) {
    list = await this.createData(list, key, value);
    console.log("list", list)
    const profileModal = this.modalController.create(SearchPage, { data: { list: list, header: title } }, { cssClass: 'managers', enableBackdropDismiss: true });
    profileModal.onDidDismiss(data => {
      console.log(data);
      if(value == "location" &&data.id == "other"){
        this.showOtherLocatiion = true;
      }else if(value == "location" && data.id != "other"){
        this.createFuel.get("other_location").setValue("");
        this.showOtherLocatiion = false;
      }

      if(value == "fleet_no" && data.id == "hire_machine"){
        this.openHireRating();
      }else if(value == "fleet_no" && data.id != "hire_machine"){
        this.createFuel.get("fleet_vahicle_type").setValue("");
        this.createFuel.get("fleet_description").setValue("");
      }

      if (data) {
        this.createFuel.get(formkey).setValue(data.key);
        this[model] = data.value;
      }
    });
    profileModal.present();

  }
  
  async openHireRating() {
    let payload = {
      "vehicleName":  this.createFuel.value.fleet_vahicle_type,
      "vehicleDescription":  this.createFuel.value.fleet_description
    };
    const modal = await this.modalController.create(
      SelectHireMachinePage,
      {
        data:payload,
        isKlmr:true
      },
      { enableBackdropDismiss: false }
    );
    modal.onDidDismiss((status) => {
      if(status){
        this.createFuel.get("fleet_vahicle_type").setValue(status.vehicleName);
        this.createFuel.get("fleet_description").setValue(status.vehicleDescription);
      }
     
     console.log("status",status);
     console.log("value is ", this.createFuel.value);
    });
    await modal.present();

  }

  validateNumber(formkey) {
    // let value = this.createFuel.value[formkey];
    // const reg = /^\d+\.?\d*$/;
    // let status = reg.test(value);
    // if (!status) {
    //   this.utiltiy.toaster("Invalid Number");
    //   this.createFuel.get(formkey).setValue("");
    //   if (formkey == "fuel") {
    //     this.createFuel.get('amount').setValue("");
    //   }
    // }

  }

  async getFleetList() {
    this.fleetList = [];
    this.utiltiy.startLoading();
    return this.api.get("/prestart/fleet/get", false)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
        if (result.status) {
          return result.result;
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      })
  }
  async getFilledBtList() {
    this.filledByList = [];
    this.utiltiy.startLoading();
    return this.api.get("/prestart/fuel/users/get", false)
      .then((result: any) => {
        console.log("result", result)
        result.result.forEach(element => {
          element.name = element.firstName + " " + element.surname;
        });
        this.utiltiy.stopLoading();
        if (result.status) {
          return result.result;
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      })
  }
  async getFuelLocationList() {
    this.filledByList = [];
    // this.utiltiy.startLoading();
    let formData: FormData = new FormData();
    formData.append("method_name", "get_location");
    return this.api.post("/prestart/fuel/fuel/Fuel_location", false, formData)
      .then((result: any) => {
        console.log("result", result)

        // this.utiltiy.stopLoading();
        if (result.status) {
          return result.result;
        }
      }, err => {
        // this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      })
  }

  regenerateForm() {
    this.createFuel.patchValue({
      filled_by: this.params.filled_by,
      date: this.params.date,
      odometer: this.params.odometer,
      diesel: this.params.diesel,
      container: this.params.container,
      fleet_no: this.params.fleet_no,
      fuel: this.params.fuel,
      fuel_odr: this.params.fuel_odr,
      amount: this.params.amount,
      location: this.params.location,
      fuel_station: this.params.fuel_station,
      other_location: this.params.other_location,
      fleet_vahicle_type: this.params.fleet_vahicle_type,
      fleet_description: this.params.fleet_description
    });

    if(this.params.location.toLowerCase() == "other"){
      this.showOtherLocatiion = true;
    }
   
    if(this.params.fleet_no == "hire_machine"){
      this.openHireRating();
    }

    this.serviceStationName = this.params.fuel_station;
    this.filledBy = this.params.filled_by;
    this.selectedConatiner = this.params.container;
    // this.selectedFleet = this.params.fleet_no;
    this.selectedFuel = this.params.diesel;
    this.selectedLocation = this.params.location;
  }

  getCentrePerLitre() {
    if (this.params.container == "Service Sation") {
      let centrePerLitre = (parseFloat(this.params.amount) / parseFloat(this.params.fuel));
      // this.createFuel.get('center_per_litre').setValue(centrePerLitre);
      if (!isNaN(centrePerLitre)) {
        this.perLitreAmount = centrePerLitre.toFixed(2);;
        this.createFuel.get('center_per_litre').setValue(this.perLitreAmount);

      }
    } else {
      let centrePerLitre = (parseFloat(this.params.amount) / parseFloat(this.params.fuel));
      if (!isNaN(centrePerLitre)) {

        this.perLitreAmount = centrePerLitre.toFixed(2);
        this.createFuel.get('center_per_litre').setValue(this.perLitreAmount);

      }
    }

  }

  dropDownChange(value, key) {
    this.createFuel.get(`${key}`).setValue(value);
    if (key == "diesel" || key == "container") {
      this.fuelCalculator();
    }
  }

  async containerChanged() {
    let option = {
      "title": 'Centre Per Litre',
      "approveText": 'save',
      "key": 'center_per_litre',
    };
    console.log(this.createFuel.value.container)
    // if (this.createFuel.value.container == "Service Sation") {
    //   let amount: any = await this.utiltiy.commonInputDialog(option);
    //   console.log("amount-->", amount)
    //   if (amount) {
    //     this.createFuel.get('fuel').setValue("");
    //     this.createFuel.get('amount').setValue("");
    //     this.createFuel.get('location').setValue("");

    //     this.perLitreAmount = amount.toFixed(2);
    //     console.log("this.perLitreAmount", this.perLitreAmount)
    //     this.createFuel.get('center_per_litre').setValue(this.perLitreAmount);
    //   }
    // }
  }

  fuelCalculator() {
    // this.validateNumber("fuel");
    if (this.createFuel.value.container.length != 0 && this.createFuel.value.diesel.length != 0 && this.createFuel.value.fuel.length != 0) {
      this.fetchAmount();
    }
  }

  fetchAmount() {
    console.log(this.createFuel.value.container)
    if (this.createFuel.value.container == "Service Sation") {
      let amount: any = (parseFloat(this.createFuel.value.fuel) * parseFloat(this.createFuel.value.center_per_litre));
      console.log("==amount", amount)
      amount = parseFloat(amount).toFixed(2);
      this.createFuel.get('amount').setValue(amount);

      return;
    }

    this.createFuel.get('center_per_litre').setValue("");
    this.createFuel.get('amount').setValue("");
    // this.utiltiy.startLoading();
    let formData: FormData = new FormData();
    formData.append("container", this.createFuel.value.container);
    formData.append("diesel", this.createFuel.value.diesel);
    formData.append("fuel", this.createFuel.value.fuel);
    this.api.post(`/prestart/fuel/fuel/detail`, false, formData)
      .then((result: any) => {
        // this.utiltiy.stopLoading();
        if (result.status) {
          if (result.result.success) {
            let centrePerLitre = (parseFloat(result.result.price) / parseFloat(this.createFuel.value.fuel));
            if (!isNaN(centrePerLitre)) {
              this.perLitreAmount = centrePerLitre.toFixed(2);
              this.createFuel.get('center_per_litre').setValue(this.perLitreAmount);

            }
            let amnt = parseFloat(result.result.price).toFixed(2);
            this.createFuel.get('amount').setValue(amnt);
          } else {
            this.utiltiy.toaster(result.result.error);
          }
        }else{
          this.perLitreAmount = null;
          this.createFuel.get('center_per_litre').setValue("");
        }

      }, err => {
        console.log("err", err)
        // this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }

  submit() {
    this.disableSubmit = true;
    this.utiltiy.startLoading();
    console.log("this.credentialsForm.value", this.createFuel.value)
    let formKeys = Object.keys(this.createFuel.value);
    if (this.isUpdate) {
      let string = "";
      formKeys.forEach(key => {
        // if (key != "center_per_litre") {
        if (string.length == 0) {
          string = string + "" + key + "=" + this.createFuel.value[key];
        } else {
          string = string + "&" + key + "=" + this.createFuel.value[key];
        }
        // }
      });
      let body = string;
      console.log("string-1", body);
      this.updateFuel(body, this.params.id);
    } else {
      let formData: FormData = new FormData();
      formKeys.forEach(key => {
        // if (key != "center_per_litre") {
        formData.append(key, this.createFuel.value[key]);
        // }
      });
      this.addFuel(formData);
    }



  }

  addFuel(formData) {
    this.api.post(`/prestart/fuel/fuel/store`, false, formData)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
    this.disableSubmit = false;

        if (result.status) {
          this.utiltiy.toaster(result.message);
          this.navCtrl.setRoot(KlmrFuelPage);
        }

      }, err => {
        console.log("err", err)
        this.utiltiy.stopLoading();
    this.disableSubmit = false;
        this.utiltiy.toaster(err.error.message);
      })
  }

  updateFuel(formData, id) {
    this.api.put(`/prestart/fuel/fuel/update/${id}`, false, formData)
      .then((result: any) => {
        console.log("result", result)
    this.disableSubmit = false;

        this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          this.navCtrl.setRoot(KlmrFuelPage);
        }

      }, err => {
        console.log("err", err)
    this.disableSubmit = false;

        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }

  async getPermission() {
    this.actionAllowed = await this.utiltiy.getPagePermission("klmr-fuel-rw");
  }

}



// WEBPACK FOOTER //
// ./src/pages/klmr-fuel-add/klmr-fuel-add.ts